import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BallotService } from "../ballot/ballot.service";
import {ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { ReviewComponent } from './review.component';
import { BallotErrorModalModule } from '../ballot/ballot-error-modal.module';
import { HeaderModule } from '../header/header.module';
import { SessionTimeoutModalModule } from '../session-timeout-modal/session-timeout-modal.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {ProgressBarModule} from '../progress-bar/progress-bar.module'
import { BackButtonConfirmationModalModule } from "../back-button-confirmation-modal/back-button-confirmation-modal.module";

@NgModule({
  declarations: [
    ReviewComponent,
  ],
  providers: [
    BallotService,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    BallotErrorModalModule,
    HeaderModule,
    SessionTimeoutModalModule,
    MatProgressSpinnerModule,
    ProgressBarModule,
    BackButtonConfirmationModalModule
  ],
})
export class ReviewModule {}
